import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Container, CssBaseline, Typography, Button, TextField } from '@material-ui/core'
import { signIn } from '../modules/app'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const SignIn = () => {
  const classes = useStyles()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const dispatch = useDispatch()

  const inputEmail = useCallback(
    (event) => {
      setEmail(event.target.value)
    },
    [setEmail]
  )

  const inputPassword = useCallback(
    (event) => {
      setPassword(event.target.value)
    },
    [setPassword]
  )

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          PLUM WEBBOOKS ADMIN
        </Typography>
        <div className={classes.form}>
          <TextField
            margin="dense"
            fullWidth
            label="Eメールアドレス"
            required
            type="email"
            value={email}
            onChange={inputEmail}
          />
          <TextField
            margin="dense"
            fullWidth
            label="パスワード"
            required
            type="password"
            value={password}
            onChange={inputPassword}
          />
          <Button
            className={classes.submit}
            variant="contained"
            color="primary"
            onClick={() => dispatch(signIn(email, password))}
          >
            サインイン
          </Button>
        </div>
      </div>
    </Container>
  )
}

export default SignIn
